import { ReactNode } from "react";

import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

export interface LayoutProps {
    columnHeaders: ReactNode;
    cards: ReactNode;
}

export const Layout = (props: LayoutProps) => {
    return (
        <div css={layoutCss}>
            {props.columnHeaders}
            {props.cards}
        </div>
    );
};

const layoutCss = css({
    width: "100%",
    maxWidth: "1120px",
    display: "grid",
    gridTemplateRows: "auto",
    rowGap: token("space.300")
});
